/**
 * Format currency value for display
 */
export function formatCurrency(value: number | undefined, currency: string = 'THB'): string {
  if (value === undefined || value === null) return '—';
  const symbols: Record<string, string> = {
    THB: '฿',
    USD: '$',
    EUR: '€',
    GBP: '£',
  };
  const symbol = symbols[currency] || currency;
  return `${symbol}${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
